import React, { Component } from "react";

import arrow_left from "../Images/arrow_left.png";
import arrow_right from "../Images/arrow_right.png";

import "./Book.scss";

class Book extends Component {
  constructor(props) {
    super(props);

    this.state = {
      book_index: 0
    };
  }
  render() {
    const { books } = this.props;
    const { book_index } = this.state;

    return (
      <div className="book">
        {book_index !== 0 && (
          <div
            className="arrow-left"
            onClick={() => {
              this.setState({
                book_index: book_index - 1
              });
            }}
          >
            <img src={arrow_left} alt="Pijltje Links" />
          </div>
        )}
        <div>
          <img src={books[book_index]} className="book_img" alt="Boek" />
        </div>
        {book_index < books.length - 1 && (
          <div
            className="arrow-right"
            onClick={() => {
              this.setState({
                book_index: book_index + 1
              });
            }}
          >
            <img src={arrow_right} alt="Pijltje Rechts" />
          </div>
        )}
      </div>
    );
  }
}

export default Book;
